import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLocation, useLink } from '@grandvisionhq/frk-routing';
import { useMutation } from '@grandvisionhq/graphql';
import { useDispatch, useIntl } from '@grandvisionhq/state';
import { getSessionStorageItem } from '@grandvisionhq/utils';
import { logSocialLoginEvent } from '../data-layer/social-login.js';
import { parseHash } from '../Login/actions.js';
import { ACTIVATE_SOCIAL_ACCOUNT } from '../operations/mutations/activate-social-account.js';
import { REQUEST_SOCIAL_LOGIN_MERGE } from '../operations/mutations/request-social-login-merge.js';

function useSocialLoginMethod() {
    const dispatch = useDispatch();
    const { replace  } = useLocation();
    const { getLabel  } = useIntl();
    const labels = {
        socialLoginError: getLabel('account.socialModal.socialLoginError')
    };
    const { href: profileRoute  } = useLink({
        route: 'me.profile'
    }) || {};
    const returnPathFromSession = getSessionStorageItem('login_returnPath');
    const returnPathAfterLogin = returnPathFromSession != null && returnPathFromSession != '"/"' ? returnPathFromSession.replace(/['"]+/g, '') : profileRoute || '';
    const continueToParseHash = React.useCallback(()=>{
        replace(returnPathAfterLogin);
        dispatch(parseHash());
    }, [
        dispatch,
        replace,
        returnPathAfterLogin
    ]);
    /**
   * This mutation responds with any accounts with same email address.
   */ const [activateSocialAccount] = useMutation(ACTIVATE_SOCIAL_ACCOUNT, {
        onCompleted () {
            logSocialLoginEvent({
                type: 'sign_in_google_successful'
            });
        },
        onError () {
            toast.failed(labels.socialLoginError);
        }
    });
    /**
   * This mutation merges the two accounts with same email address.
   */ const [requestSocialLoginMerge, {}] = useMutation(REQUEST_SOCIAL_LOGIN_MERGE, {
        onCompleted: ()=>{
            logSocialLoginEvent({
                type: 'merge_account_success'
            });
            continueToParseHash();
        },
        onError: (err)=>{
            logSocialLoginEvent({
                type: 'merge_account_error',
                errorMessage: err.message
            });
        }
    });
    const handleSocialLogin = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        try {
            const { data  } = yield activateSocialAccount();
            const hasAdditionalAccounts = Boolean(data === null || data === void 0 ? void 0 : data.activateSocialAccount.mergeableAccounts.length);
            if (hasAdditionalAccounts) {
                /**
         * Auto merge accounts when related accounts are present and mergeable.
         */ logSocialLoginEvent({
                    type: 'merge_account_modal_view'
                });
                requestSocialLoginMerge();
            } else {
                continueToParseHash();
            }
        } catch (e) {
            const message = 'Unknown error while activating social account';
            console.error(message, e);
        }
    }), [
        activateSocialAccount,
        requestSocialLoginMerge,
        continueToParseHash
    ]);
    return React.useMemo(()=>({
            handleSocialLogin
        })
    , [
        handleSocialLogin
    ]);
}

export { useSocialLoginMethod };
//# sourceMappingURL=use-social-login-method.js.map
